import React, { useEffect, useContext } from "react";
import { useMounted } from "hooks/useMounted/index";
import { TokenLocalStorageKey, NotAuthPages } from "base/Constant";
import UserModel, { useUserHook } from "models/userModel";
import ToastMsg from "components/Toast/index";

const AppContenxt = React.createContext({});

const AppProvider = ({ children }) => {
    const userModel = useUserHook(UserModel.Context);
    const isMounted = useMounted();

    const handleQueryInfo = async () => {
        const token = localStorage.getItem(TokenLocalStorageKey);
        const pathname = window.location.pathname;
        if (!token) {
            if (!NotAuthPages.includes(pathname)) {
                const redirect = encodeURIComponent(`${pathname}${window.location.search}`)
                window.location.href = `${window.location.origin}/?redirect=${redirect}`;
            }
            userModel.setUserData(null);
            return;
        }

        const isLogin = await userModel.getMe();

        if (isLogin && pathname === '/') {
            window.location.href = '/home';
        }
    };

    useEffect(() => {
        if (!isMounted) return;
        handleQueryInfo();
    }, [isMounted]);

    if (!isMounted) {
        return <></>
    }

    return (
        <AppContenxt.Provider value={{}}>
            {children}
        </AppContenxt.Provider>
    )
}

export { AppContenxt, AppProvider }